import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { AlertPopups } from "../../../components/AlertPopups";

function FormHeaderButton(props) {
  const { title, icon, onClick, Vendor, selectedItemCategory } = props;
  return (
    <>
      {Vendor ? (
        <div
          onClick={() => {
            if (
              selectedItemCategory === undefined ||
              selectedItemCategory === null
            ) {
              AlertPopups.ErrorAlert.fire({
                text: "Select Item Category First",
              });
            } else props.showModal();
          }}
          style={{ cursor: "pointer" }}
          className="mr-3"
        >
          {title}
          <FontAwesomeIcon icon={icon} className="px-2" />
        </div>
      ) : (
        <div onClick={onClick} style={{ cursor: "pointer" }} className="mr-3">
          {title}
          <FontAwesomeIcon icon={icon} className="px-2" />
        </div>
      )}
    </>
  );
}

export default FormHeaderButton;
